var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.createStory.apply(null, arguments)
        }
      }
    },
    [
      _c("div", { staticClass: "card" }, [
        _c("div", { staticClass: "card-header" }, [_vm._v("New Project")]),
        _vm._v(" "),
        _c("div", { staticClass: "card-body" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-8" }, [
              _vm.newStory.imageUrl
                ? _c("img", {
                    attrs: {
                      src: _vm.newStory.imageUrl,
                      height: "150",
                      alt: "preview not available"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn-primary upload-file-button pad-5",
                  attrs: { type: "button" },
                  on: { click: _vm.pickFile }
                },
                [_vm._v("\n            +")]
              ),
              _vm._v("  "),
              _c("span", { staticClass: "text-right pad-top-20" }, [
                _vm._v("Upload Image")
              ]),
              _vm._v(" "),
              _c("input", {
                ref: "image",
                staticStyle: { display: "none" },
                attrs: { type: "file", accept: "image/*" },
                on: { change: _vm.onFilePicked }
              })
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row pad-top-20" }, [
            _c("div", { staticClass: "col-8" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.newStory.title,
                    expression: "newStory.title"
                  }
                ],
                staticClass: "form-control text-field-style",
                attrs: {
                  type: "text",
                  placeholder: "Project Title",
                  required: ""
                },
                domProps: { value: _vm.newStory.title },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.newStory, "title", $event.target.value)
                  }
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row pad-top-20" }, [
            _c("div", { staticClass: "col-8" }, [
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.newStory.subtitle,
                    expression: "newStory.subtitle"
                  }
                ],
                staticClass: "form-control text-field-style",
                attrs: { rows: "3", cols: "5", placeholder: "Description" },
                domProps: { value: _vm.newStory.subtitle },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.newStory, "subtitle", $event.target.value)
                  }
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row pad-top-20" }, [
            _c("div", { staticClass: "col-8" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.newStory.organization,
                    expression: "newStory.organization"
                  }
                ],
                staticClass: "form-control text-field-style",
                attrs: { type: "text", placeholder: "Organization (optional)" },
                domProps: { value: _vm.newStory.organization },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.newStory, "organization", $event.target.value)
                  }
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row pad-top-20" }, [
            _c("div", { staticClass: "col-8" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.newStory.team,
                    expression: "newStory.team"
                  }
                ],
                staticClass: "form-control text-field-style",
                attrs: { type: "text", placeholder: "Team (optional)" },
                domProps: { value: _vm.newStory.team },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.newStory, "team", $event.target.value)
                  }
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row pad-top-20" }, [
            _c(
              "div",
              { staticClass: "col-8 flexSpaceBetween text-right" },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "btn btn-primary text-field-style",
                    attrs: { to: { name: "projects" } }
                  },
                  [_vm._v("\n            Previous\n          ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary text-field-style",
                    attrs: { type: "submit" }
                  },
                  [_vm._v("\n            Next\n          ")]
                )
              ],
              1
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1c93be2a", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c93be2a","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/v2/add_story/step1.vue
// module id = null
// module chunks = 